export const API_URL = "https://valerotexasopen.com/championsforecharity/api";
//export const RECAPTCHA_KEY = "6LfkuhkUAAAAAMtYySi117tvZtrs0fzC2RzCVrEE";
export const TURNSTILE_KEY = "0x4AAAAAAFSbGqNc7uSptUAQ";

export const FORTE_API = "NPY7QXiofV";
export const FORTE_SCRIPT = "https://api.forte.net/js/v1";
/*
  live is NPY7QXiofV (dash = O38g6Tiw1T), https://api.forte.net/js/v1
  sandbox is ibEssZCZQ, https://sandbox.forte.net/api/js/v1
*/

export function createMarkup(html) {
	return { __html: html };
}

export function isFieldError(array, val) {
	return array.includes(val);
}

export function scroll() {
	return window.jQuery("html, body").animate(
		{
			scrollTop:
				window.jQuery("h1").offset().top - window.jQuery("#header").height(),
		},
		200,
	);
}

const isBrowser = () => typeof window !== "undefined";

export const getValFromLS = (key, useSessionStorage = false) => {
	if (useSessionStorage) {
		return isBrowser() && window.sessionStorage.getItem(key)
			? window.sessionStorage.getItem(key)
			: undefined;
	} else {
		return isBrowser() && window.localStorage.getItem(key)
			? window.localStorage.getItem(key)
			: undefined;
	}
};

export const setValToLS = (key, val, useSessionStorage = false) => {
	if (isBrowser() && val) {
		useSessionStorage
			? window.sessionStorage.setItem(key, val)
			: window.localStorage.setItem(key, val);
	} else {
		useSessionStorage
			? window.sessionStorage.removeItem(key)
			: window.localStorage.removeItem(key);
	}
	return true;
};

export const ready2Submit = (obj) => {
	return obj.info &&
		obj.contact &&
		obj.documents &&
		obj.pledge &&
		obj.promote &&
		obj.deandi
		? true
		: false;
};

export const isCardType = (str) => {
	str = str.replace(/\s/g, "").replace(/-/g, "");
	const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
	const mast = /^(?:5[1-5][0-9]{14})$/;
	const amex = /^(?:3[47][0-9]{13})$/;
	const disc = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
	if (str.match(visa)) {
		return "visa";
	} else if (str.match(mast)) {
		return "mast";
	} else if (str.match(amex)) {
		return "amex";
	} else if (str.match(disc)) {
		return "disc";
	} else {
		return "not a card";
	}
};

export function fmtCurrency(int, cents = 2) {
	const amt = int;
	return `${amt.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: cents,
		maximumFractionDigits: cents,
	})}`;
}

export function isValidEmail(email) {
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(email);
}
